import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import {
  clsx_default
} from "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/ImageFrame/ImageFrame.tsx
import * as React from "react";
import { useComponentsTranslation } from "../../../i18n/useComponentsTranslation.mjs";
import { ProductBagIcon } from "./ProductBagIcon.mjs";
import { jsx } from "react/jsx-runtime";
var imageFrameVariants = cva("buyscout-image-frame", {
  variants: {
    fallback: {
      "bag": "buyscout-image-frame--fallback-bag",
      "bag-filled": "buyscout-image-frame--fallback-bag-filled",
      "alt": "buyscout-image-frame--fallback-alt",
      "none": ""
    }
  },
  defaultVariants: {
    fallback: "none"
  }
});
function ImageFrame({
  ref,
  src,
  srcSet,
  sizes,
  alt,
  fallback = "none",
  loading,
  decoding,
  fetchPriority,
  crossOrigin,
  referrerPolicy,
  className,
  imgClassName,
  onLoad,
  onError,
  ...rest
}) {
  const { t } = useComponentsTranslation();
  const imgRef = React.useRef(null);
  const key = `${src ?? ""} ${srcSet ?? ""}`;
  const [settled, setSettled] = React.useState(null);
  const current = settled?.key === key ? settled : null;
  const state = !src ? "error" : current?.state ?? "loading";
  React.useLayoutEffect(() => {
    const img = imgRef.current;
    if (img?.complete && img.naturalWidth > 0) {
      setSettled({ key, state: "loaded", instant: true });
    }
  }, [key]);
  const handleLoad = (event) => {
    setSettled((prev) => prev?.key === key && prev.state === "loaded" ? prev : { key, state: "loaded", instant: false });
    onLoad?.(event);
  };
  const handleError = (event) => {
    setSettled({ key, state: "error", instant: false });
    onError?.(event);
  };
  let content = null;
  if (state !== "error") {
    content = /* @__PURE__ */ jsx(
      "img",
      {
        ref: imgRef,
        className: clsx_default("buyscout-image-frame__img", imgClassName),
        src,
        srcSet,
        sizes,
        alt,
        loading,
        decoding,
        fetchPriority,
        crossOrigin,
        referrerPolicy,
        draggable: false,
        onLoad: handleLoad,
        onError: handleError
      }
    );
  } else if (fallback === "alt") {
    content = alt || t("chatMessage.imageUnavailable");
  } else if (fallback === "bag" || fallback === "bag-filled") {
    content = /* @__PURE__ */ jsx(
      "span",
      {
        className: "buyscout-image-frame__fallback",
        ...alt ? { "role": "img", "aria-label": alt } : { "aria-hidden": true },
        children: /* @__PURE__ */ jsx(ProductBagIcon, { variant: fallback === "bag" ? "outline" : "filled" })
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "span",
    {
      ref,
      className: imageFrameVariants({ fallback, className }),
      "data-state": state,
      "data-instant": current?.instant || void 0,
      ...rest,
      children: content
    }
  );
}
ImageFrame.displayName = "ImageFrame";
export {
  ImageFrame
};
//# sourceMappingURL=ImageFrame.mjs.map